module.exports = __webpack_public_path__ + "static/lucaswork6-58617b2201d5cc739fe1bc1e7ffa250c.jpg";